"use client";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const handleNavigation = (path) => navigate(path);

  return (
    <div>
      <main className="flex pb-4 w-full h-auto bg-[#fff8ef] max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
        <section className="flex flex-col flex-1 gap-5 min-w-0">
          <div className="bg-[#fff8ef] h-auto">

            {/* Card */}
            <div className="bg-white rounded-2xl shadow-lg mt-4 p-8 max-w-5xl mx-auto">

              {/* Title */}
              <div className="flex items-center justify-center gap-3 mb-8">
                <div
            className=" text-3xl sm:text-3xl md:text-3xl lg:text-4xl 
      font-bold leading-none text-black 
      tracking-[1px] md:tracking-[2px] 
      hover:opacity-80 transition-opacity duration-200 
      flex-shrink-0 min-w-0
      
      lg:[-webkit-text-stroke:2px_gray-700]"
            
            aria-label="Manaprint Home"
          >
            Cookie Policy
          </div>
                  
              </div>

              {/* Content */}
              <div className="space-y-6 text-gray-700 leading-relaxed">

                <p>
                  This Cookie Policy explains how <strong>Manaprint</strong> uses cookies 
                  and similar technologies to recognize you when you visit our website.
                </p>

                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    1. What Are Cookies?
                  </h2>
                  <p>
                    Cookies are small text files stored on your device when you 
                    visit a website. They help improve your browsing experience 
                    by remembering preferences and enabling essential site functions.
                  </p>
                </div>

                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    2. Types of Cookies We Use
                  </h2>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>
                      <strong>Essential Cookies:</strong> Required for basic site functionality.
                    </li>
                    <li>
                      <strong>Performance Cookies:</strong> Help us understand how visitors interact with our site.
                    </li>
                    <li>
                      <strong>Functional Cookies:</strong> Remember your preferences and settings.
                    </li>
                    <li>
                      <strong>Marketing Cookies:</strong> Used to deliver relevant advertisements.
                    </li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    3. How We Use Cookies
                  </h2>
                  <p>
                    We use cookies to improve website performance, analyze traffic, 
                    personalize content, and enhance user experience.
                  </p>
                </div>

                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    4. Managing Cookies
                  </h2>
                  <p>
                    You can control and delete cookies through your browser settings. 
                    Please note that disabling certain cookies may affect website functionality.
                  </p>
                </div>

                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    5. Changes to This Policy
                  </h2>
                  <p>
                    We may update this Cookie Policy from time to time. 
                    Any changes will be posted on this page.
                  </p>
                </div>

                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    6. Contact Us
                  </h2>
                  <p>
                    If you have any questions about our Cookie Policy, 
                    please contact us at <strong>manaprint6@gmail.com</strong>.
                  </p>
                </div>

                <p className="text-sm text-gray-500 pt-4">
                  Last updated: February 2026
                </p>

              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default CookiePolicy;